import Vue from 'vue'
import Vuex from 'vuex'
import "babel-polyfill"
Vue.use(Vuex);

export default new Vuex.Store({
    state:{
        token: true
    }
});


// WEBPACK FOOTER //
// ./src/store/store.js